import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
  selector: 'app-autobet-leave-confirm',
  templateUrl: './autobet-leave-confirm.component.html',
  styleUrl: './autobet-leave-confirm.component.scss',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutoBetLeaveConfirmComponent {
  private readonly dialogRef = inject(DialogRef);

  leave(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
